<template>
  <main>
    <Header />
    <div class="d-flex justify-content-center">
      <div class="main-content col-lg-10">
        <h3 class="text-normal mb-3 text-left font-bold">Find Us</h3>
        <GmapMap
          v-if="mapAvailable"
          ref="gmap"
          :center="{lat:6.596596, lng:3.347595}"
          :zoom="16"
          map-type-id="terrain"
          style="width: 100%; height: 500px;border-radius: 7px;"
        >
          <GmapMarker ref="myMarker"
          :position="google && new google.maps.LatLng(6.596596, 3.347595)" />
        </GmapMap>
        <img v-if="! mapAvailable" 
          src="../assets/map.png" class="img-fluid" 
          alt="Map Location fo RevolutionPlus Property Office">
        <ContactFooter />
      </div>
    </div>
    <SocialLinks />
  </main>
</template>

<script>
import Header from '../components/common/Header'
import ContactFooter from '../components/common/ContactFooter'
import SocialLinks from '../components/common/SocialLinks'
import { loadGmapApi, gmapApi } from 'vue2-google-maps'

export default {
  name: "Contact",
  metaInfo: {
    title: 'Contact Us',
  },
  computed: {
    google: gmapApi,
    getMapAPiKey() {
      return this.$store.state.mapAPIKey
    }
  },
  data() {
    return {
      mapAvailable: false,
    }
  },
  components: {
    Header,
    ContactFooter,
    SocialLinks
  },
  watch: {
    getMapAPiKey: function(newVal) {
      if (newVal) {
        loadGmapApi({
          key: newVal,
          libraries: 'places'
        })
        this.mapAvailable = true
      }
    }
  }
}
</script>

<style scoped>
.main-content {
  padding: 20px;
  background-color: #fff;
  margin-bottom: 0;
}
@media (min-width: 1200px) {
  .main-content {
    padding: 40px;
  }
}
</style>
